import React from "react";
import {
    FormControl,
    FormLabel,
    VStack,
    Select,
} from "@chakra-ui/react";
import { FormInput } from "../FormInput";


export const InviteStaffForm = ({ formData, errors, isInvitingUser = false, isUpdate = false, handleChange }) => {
    return (
        <VStack spacing={4}>
            <FormInput
                label="First Name"
                name="firstName"
                type="text"
                inputOnChange={handleChange}
                value={formData.firstName}
                formProps={{ isRequired: true }}
                padding="0"
                inputProps={{disabled: isInvitingUser, isInvalid: errors?.firstName}}
                errorMessage={errors.firstName}
            />
            <FormInput
                label="Last Name"
                name="lastName"
                type="text"
                inputOnChange={handleChange}
                value={formData.lastName}
                formProps={{ isRequired: true }}
                padding="0"
                inputProps={{disabled: isInvitingUser, isInvalid: errors?.lastName}}
                errorMessage={errors.lastName}
            />
            <FormInput
                label="Email"
                name="email"
                type="text"
                inputOnChange={handleChange}
                value={formData.email}
                formProps={{ isRequired: true }}
                padding="0"
                inputProps={{disabled: isInvitingUser || isUpdate, isInvalid: errors?.email}}
                errorMessage={errors.email}
            />
            <FormControl>
                <FormLabel>Role</FormLabel>
                <Select name="role" value={formData.role} onChange={handleChange} disabled={isInvitingUser}>
                    <option value="staff">Staff</option>
                    <option value="co-admin">Co-Admin</option>
                </Select>
            </FormControl>
        </VStack>
    );
};